import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const TextWrapper = styled(FlexColumn)`
  gap: 20px;
  align-items: center;

  ${QUERIES.largeTabletAndUp} {
    max-width: 800px;
  }

  p {
    text-align: center;
  }
`;
